import { render } from "./TextLabel.vue?vue&type=template&id=cea0d8d8&scoped=true"
import script from "./TextLabel.vue?vue&type=script&lang=js"
export * from "./TextLabel.vue?vue&type=script&lang=js"

import "./TextLabel.vue?vue&type=style&index=0&id=cea0d8d8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cea0d8d8"]])

export default __exports__